// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"5620422f","36":"d485b9d2","222":"3793c907","231":"58e97c48","318":"84654362","371":"ded3aa43","423":"8f729dd8","453":"8ab44547","465":"74780fd4","569":"08920c34","893":"d20c93f7","976":"2c94b48a"}[chunkId] + ".chunk.js";
};